
(function($, document, window) {
    'use strict';


    $(document).ready(function() {

        if ($('body').hasClass('not-logged-in')) {
            // Functionality when user is not logged in
        }

        if ($('body').hasClass('logged-in')) {
            // Functionality when user is logged in
            $(document).on('cms.ready', function() {
                // Functionality when contenda is in ready state
            });
        }
    });
})(jQuery, document, window);